const applyConfig = (config) => {
  const linkAreaPersonale =
    (__CLIENT__ && window.env.RAZZLE_LINK_AREA_PERSONALE) ||
    process.env.RAZZLE_LINK_AREA_PERSONALE ||
    '';

  config.settings = {
    ...config.settings,
    italiaThemeViewsConfig: {
      ...config.settings.italiaThemeViewsConfig,
      imagePosition: 'documentBody', // possible values: afterHeader, documentBody
    },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: undefined,
      siteSubtitle: undefined,
      subsiteParentSiteTitle: undefined,
      parentSiteTitle: 'Regione Emilia-Romagna',
      parentSiteURL: 'https://www.regione.emilia-romagna.it/',
      footerInfos: 'Via Giolitti, 22 - 41037 Mirandola (MO)',
      arLoginUrl: linkAreaPersonale,
      userLoggedMenu: [
        {
          href: {
            it: 'https://servizionline.comune.mirandola.mo.it/area-personale',
          },
          title: { it: 'Area personale' },
          className: 'area-personale-link',
        },
        ...(config.settings.siteProperties.userLoggedMenu ?? []),
      ],
    },
    showTrasparenzaFields: true,
  };
  config.settings['volto-gdpr-privacy'].defaultPanelConfig = null;

  return config;
};

export default applyConfig;
